var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"filled-bar",style:({ width: 100 - (_vm.progress * 100) + '%' })}),_vm._v(" "),_c('div',{staticClass:"percentage-text"},[_vm._v("\n         "+_vm._s(_vm.percentageText)+"\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe950840","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/site/components/stories/progress-bar.vue
// module id = V01K
// module chunks = 9